import { useState } from "react";
import { subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { ISelectOption, ITrade, ITrades } from "@miplatform/types";

export const useTrades = (): {
  getTrades: () => void;
  trades: ITrade[];
  tradeOptions: ISelectOption[];
  getTradeFromId: (id: string) => ITrade | null;
} => {
  const [trades, setTrades] = useState<ITrade[]>([]);
  const [tradeOptions, setTradeOptions] = useState<ISelectOption[]>([]);

  const stateManager = useComponentState();

  const getTrades = () => {
    stateManager.run(async () => {
      const response = await subscriptionService.trades.getAll();
      if (response.status === HTTP_STATUSES.OK) {
        const options = (response.data as ITrades[]).map(({ name, id }) => ({
          label: name,
          value: id,
        }));

        setTrades(response.data);
        setTradeOptions(options);
      }
    });
  };

  const getTradeFromId = (id: string) => {
    return trades.find((trade) => trade.id === id) ?? null;
  };

  return {
    getTrades,
    trades,
    tradeOptions,
    getTradeFromId,
  };
};
